import service from 'service';

export const getSubscribers = ({ queryKey: [, params] }) => {
  const url = '/core_subscriber/subscribers';
  return service.get(url, { params });
};

export const showSubscriber = ({ queryKey: [, id] }) => {
  const url = `/core_subscriber/subscribers/${id}/`;
  return service.get(url);
};

export const getSubscriberRequirements = ({ queryKey: [, id] }) => {
  const url = `core_subscriber/organizations/${id}/requirements`;
  return service.get(url);
};

export const updateRequirements = ({ orgId, reqId, action, payload }) => {
  const url = `/core_subscriber/organizations/${orgId}/requirements/${reqId}/${action}`;
  return service.put(url, payload);
};
